<template>

  <div class="admin-hours">

    <b-modal :active.sync="showEditHours">
      <div class="box">
        <edit-hours :day="selectedDay" :user="selectedUser" @cancel="showEditHours = false" @submit="submitHours" :can-set-overtime-paid="true"></edit-hours>
      </div>
    </b-modal>

    <div class="columns" v-if="showUserHours && selectedUser">
      <div class="column">
        <h1 class="title is-4">
          {{ selectedUser.firstName }} {{ selectedUser.lastName }}
          &nbsp;<span class="tag is-info is-clickable" @click="showUserHours = false; selectedUser = null">Back</span>
        </h1>
      </div>
    </div>

    <div class="columns is-mobile options">
      <div class="column">
        <week-select @week-changed="onWeekChanged" />
      </div>
      <div class="column has-text-right">
        <b-dropdown position="is-bottom-left" :mobile-modal="false">
          <button class="button" slot="trigger">
            <i class="fas fa-ellipsis-h"></i>
          </button>
          <b-dropdown-item custom>
            <button class="button is-small clear-button" style="width: 100%" @click="showPrintPreview">
              <i class="fas fa-print"></i>&nbsp;Print
            </button>
          </b-dropdown-item>
          <b-dropdown-item custom>
            <b-checkbox v-model="showTotals">Show&nbsp;Totals</b-checkbox>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <div class="columns">
      <div ref="container" class="column">

        <template v-if="showUserHours && selectedUser && week">
          <employee-hours :user="selectedUser" :week="week" :can-set-overtime-paid="true" />
        </template>

        <template v-else>
          <table v-if="users && days && hours" class="table is-hoverable is-striped is-bordered time-table">
            <thead class="thead-inverse">
              <tr>
                <th>User</th>
                <th v-for="day of days" :key="day.timestamp" :class="{'is-today': !printer && day.timestamp === today}">{{ day.name }}</th>
                <th v-show="showTotals" :colspan="totalSick || totalLeave ? 2 : 1">TOTAL</th>
              </tr>
            </thead>
            <tbody ref="userHoursTbody">
              <tr v-for="obj of userHours" :key="obj.user.uid" :class="{'page-break': obj.count % 10 === 0}">
                <th @click="showUserHours = true; selectedUser = obj.user">{{ obj.user.firstName }} {{ obj.user.lastName }} </th>
                <td v-for="day of obj.days" :key="obj.user.uid + day.timestamp" @click="onClickDay(obj.user, day)" :class="{'is-today': !printer &&  day.timestamp === today}">
                  <template v-if="day.sick"><b-tag type="is-success">SICK</b-tag></template>
                  <template v-else-if="day.leave"><b-tag type="is-info">LEAVE</b-tag></template>
                  <template v-else>
                    <div class="columns gapless is-mobile has-text-centered">
                      <div class="column">
                        <pretty-time :seconds="day.seconds" />
                      </div>
                      <div class="column">
                        <strong class="day-overtime" :class="{'overtime-paid': day.overtime && day.timestamp <= obj.user.overtimePaid}">
                          <pretty-time :seconds="day.overtime" />
                        </strong>
                      </div>
                    </div>
                  </template>
                </td>
                <td v-show="showTotals" class="is-total"  @click="showUserHours = true; selectedUser = obj.user">
                  <div class="columns gapless is-mobile has-text-centered">
                    <div class="column">
                      <pretty-time :seconds="obj.totalSeconds" />
                    </div>
                    <div class="column">
                      <strong>
                        <pretty-time :seconds="obj.totalOvertime" />
                      </strong>
                    </div>
                  </div>
                </td>
                <td class="is-other-total" v-if="showTotals &&  (totalSick || totalLeave)">
                  <div v-if="obj.totalSick">
                    <b-tag type="is-success">
                      <strong>
                        SICK: <pretty-time :seconds="obj.totalSick"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                  <div v-if="obj.totalLeave">
                    <b-tag type="is-info">
                      <strong>
                        LEAVE: <pretty-time :seconds="obj.totalLeave"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot v-show="showTotals">
              <tr>
                <th>TOTAL</th>
                <td v-for="total of dayTotals" :key="total.timestamp" :class="{'is-today': !printer && total.timestamp === today}">
                  <div class="columns gapless is-mobile has-text-centered">
                    <div class="column">
                      <pretty-time :seconds="total.seconds" />
                    </div>
                    <div class="column">
                      <strong>
                        <pretty-time :seconds="total.overtime" />
                      </strong>
                    </div>
                  </div>
                  <div  v-if="total.sick">
                    <b-tag type="is-success">
                      <strong>
                        SICK: <pretty-time :seconds="total.sick"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                  <div v-if="total.leave">
                    <b-tag type="is-info">
                      <strong>
                        LEAVE: <pretty-time :seconds="total.leave"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                </td>
                <td>
                  <div class="columns gapless is-mobile has-text-centered">
                    <div class="column">
                      <pretty-time :seconds="totalSeconds" />
                    </div>
                    <div v-if="totalOvertime" class="column">
                      <strong>
                        <pretty-time :seconds="totalOvertime" />
                      </strong>
                    </div>
                  </div>
                <td v-if="totalSick || totalLeave">
                  <br />
                  <div v-if="totalSick">
                    <b-tag type="is-success">
                      <strong>
                        SICK: <pretty-time :seconds="totalSick"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                  <div v-if="totalLeave">
                    <b-tag type="is-info">
                      <strong>
                        LEAVE: <pretty-time :seconds="totalLeave"></pretty-time>
                      </strong>
                    </b-tag>
                  </div>
                </td>
              </tr>
            </tfoot>
          </table>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
import WeekSelect from '../../components/WeekSelect'
import PrettyTime from '../../components/PrettyTime'
import EditHours from '../../components/EditHours'
import EmployeeHours from '../../components/EmployeeHours'
import { PrintUtils } from '@/utils/print.js'
export default {
  name: 'AdminHours',
  components: {
    WeekSelect,
    PrettyTime,
    EditHours,
    EmployeeHours
  },
  data () {
    return {
      today: 0,
      week: null,
      weekStartingStr: '',
      users: null,
      days: null,
      hours: null,
      userHours: null,
      showTotals: true,
      dayTotals: {},
      totalSeconds: 0,
      totalOvertime: 0,
      totalSick: 0,
      totalLeave: 0,
      dateFormat: 'ddd Do',
      showEditHours: false,
      selectedUser: null,
      selectedDay: null,
      showUserHours: false
    }
  },
  computed: {
    workingSecondsPerDay () { return this.$store.getters.workingSecondsPerDay },
    printer () { return this.$store.getters.printer }
  },
  watch: {
    users () { this.updateUserHours() },
    days () { this.updateUserHours() },
    hours () { this.updateUserHours() }
  },
  created () {
    this.today = this.$moment().startOf('day').unix()
    this.subs.users = this.$firestore
      .collection('users')
      .onSnapshot(this.userSnapshot)
  },
  methods: {
    updateUserHours () {
      if (!this.users || !this.days || !this.hours) {
        this.userHours = null
        return
      }
      console.log('updateUserHours')
      let userHours = {}
      let dayTotalsSet = false
      let dayTotals = {}
      let count = 0
      this.users.forEach(user => {
        count++
        let days = {}
        this.days.forEach(day => {
          if (!dayTotalsSet) {
            dayTotals[day.timestamp] = {
              timestamp: day.timestamp,
              seconds: 0,
              overtime: 0,
              sick: 0,
              leave: 0
            }
          }
          days[day.timestamp] = {
            uid: user.uid,
            timestamp: day.timestamp
          }
        })
        dayTotalsSet = true
        userHours[user.uid] = {
          count,
          user,
          days,
          totalSeconds: 0,
          totalOvertime: 0,
          totalSick: 0,
          totalLeave: 0
        }
      })
      let totalSeconds = 0
      let totalOvertime = 0
      let totalSick = 0
      let totalLeave = 0
      this.hours.forEach(h => {
        if (userHours[h.uid] && userHours[h.uid].days[h.timestamp]) {
          userHours[h.uid].days[h.timestamp] = h
          if (h.sick) {
            userHours[h.uid].totalSick += this.workingSecondsPerDay
            dayTotals[h.timestamp].sick += this.workingSecondsPerDay
            totalSick += this.workingSecondsPerDay
          } else if (h.leave) {
            userHours[h.uid].totalLeave += this.workingSecondsPerDay
            dayTotals[h.timestamp].leave += this.workingSecondsPerDay
            totalLeave += this.workingSecondsPerDay
          } else {
            userHours[h.uid].totalSeconds += h.seconds
            userHours[h.uid].totalOvertime += h.overtime
            dayTotals[h.timestamp].seconds += h.seconds
            dayTotals[h.timestamp].overtime += h.overtime
            totalSeconds += h.seconds
            totalOvertime += h.overtime
          }
        }
      })
      this.totalSeconds = totalSeconds
      this.totalOvertime = totalOvertime
      this.totalSick = totalSick
      this.totalLeave = totalLeave
      this.dayTotals = dayTotals
      this.userHours = userHours
    },
    onClickDay (user, day) {
      this.selectedUser = user
      this.selectedDay = day
      if (!this.selectedDay.start) this.selectedDay.start = null
      if (!this.selectedDay.end) this.selectedDay.end = null
      this.showEditHours = true
    },
    submitHours (day) {
      let docId = `${day.uid}-${this.$moment.unix(day.timestamp).format('YYYYMMDD')}`
      this.$firestore
        .collection('user-hours')
        .doc(docId)
        .set(day)
      this.$toast.open({
        message: 'Hours submitted!',
        type: 'is-info'
      })
      this.showEditHours = false
    },
    onWeekChanged (week) {
      this.week = week.clone()
      let days = []
      let format = this.isPhone ? 'ddd Do MMM YYYY' : 'dddd Do MMMM YYYY'
      this.weekStartingStr = week.format(format)
      let fromTimestamp = 0
      let toTimestamp = 0
      for (let i = 0; i < 7; i++) {
        let timestamp = week.unix()
        if (i === 0) fromTimestamp = timestamp
        else if (i === 6) toTimestamp = timestamp
        days.push({
          timestamp,
          name: week.format(this.dateFormat)
        })
        week.add(1, 'd')
      }
      this.days = days

      this.unsub('userHours')
      this.subs.userHours = this.$firestore
        .collection('user-hours')
        .where('timestamp', '>=', fromTimestamp)
        .where('timestamp', '<=', toTimestamp)
        .onSnapshot(this.userHoursSnapshot)
    },
    userSnapshot (snapshot) {
      let users = []
      snapshot.docs.forEach(doc => {
        let data = doc.data()
        if (data.privileges && data.privileges.indexOf('time keeping') >= 0) {
          users.push(data)
          if (this.selectedUser && this.selectedUser.uid === data.uid) {
            this.selectedUser = data
          }
        }
      })
      this.users = users
    },
    userHoursSnapshot (snapshot) {
      let hours = []
      snapshot.docs.forEach(doc => hours.push(doc.data()))
      this.hours = hours
    },
    showPrintPreview () {
      let html = `
        Week starting ${this.weekStartingStr}
        ${this.$refs.container.innerHTML}`
      let title = `Hours - ${this.weekStartingStr}`
      PrintUtils.print({
        html,
        title,
        orientation: 'landscape',
        pageStyle: true
      })
    }
  }
}
</script>

<style>

.admin-hours table .columns,
.admin-hours table .column {
  margin: 0;
  padding: 0;
}

.admin-hours table tbody th,
.admin-hours table tbody td {
  vertical-align: middle;
}

.admin-hours table tbody th {
  cursor: pointer;
}

.admin-hours table tfoot td {
  border: solid 1px #dbdbdb;
  border-top: solid 2px #666;
}

.admin-hours table.is-bordered tbody th {
  border-left: solid 1px #dbdbdb;
  border-right: solid 2px #666;
}

.admin-hours table tbody td.is-total {
  border: solid 1px #dbdbdb;
  border-left: solid 2px #666;
}

.admin-hours table tbody td.is-other-total {
  border: solid 1px #dbdbdb;;
  background-color: #eee;
}

.admin-hours table tfoot td:last-child {
  border-left: solid 2px #666;
}

.admin-hours table th.is-today,
.admin-hours table tr td.is-today {
  border-right: solid 2px #0000ff;
  border-left: solid 2px #0000ff;
}

.admin-hours table thead th.is-today {
  border-top: solid 2px #0000ff;
}

.admin-hours table tfoot td.is-today {
  border-bottom: solid 2px #0000ff !important;
}

.admin-hours table td.is-total {
  background-color: #eee;
}

 .admin-hours .dropdown-menu {
  margin-bottom: 5px;
  min-width: auto;
  /* text-align: left; */
}

.admin-hours .dropdown-menu .dropdown-content {
  padding: 0;
  background-color: #eee;
}

.printer .admin-hours .options {
  display: none;
}

</style>
